module.exports = __webpack_public_path__ + "assets/fonts/Foco-Bold-f4349a07f4e98eac20d67a417e6d8544.ttf";